/**
 * Default feature flag values when PostHog is unavailable or a flag is missing.
 * Shared so mobile (and future web flag keys) stay aligned.
 */
export const DEFAULT_FEATURE_FLAGS = {
    app_access: false,
    perpetual_trading_enabled: false,
    new_home_layout: false,
    advanced_charts: false,
    social_features: false,
    login_phone_enabled: true,
    login_email_enabled: true,
    login_cex_enabled: true,
    login_import_wallet_enabled: true,
    login_google_enabled: false,
    login_apple_enabled: true,
    login_direct_email_enabled: true,
    home_tab_enabled: false,
    signals_tab_enabled: false,
};
